module.exports = __webpack_public_path__ + "static/img/scrollImg5.7cc340a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scrollImg5.png
// module id = 2mPc
// module chunks = 2